import { render, staticRenderFns } from "./PageStep.vue?vue&type=template&id=3554a0df&scoped=true&"
import script from "./PageStep.vue?vue&type=script&lang=js&"
export * from "./PageStep.vue?vue&type=script&lang=js&"
import style0 from "./PageStep.vue?vue&type=style&index=0&id=3554a0df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3554a0df",
  null
  
)

export default component.exports